








import { defineComponent } from '@vue/composition-api'
import { Document } from '@contentful/rich-text-types'
import RichTextContainer from '@/components/rich-text-container/RichTextContainer.vue'

export default defineComponent({
  props: {
    termsInfo: {
      type: Document,
      default: () => null
    }
  },
  components: {
    RichTextContainer
  }
})

